import {IProgressStep} from "../../Models/Interfaces/IProgressStep";

export interface SignupFlowCheckpoint {
    registeredUserId: string | null;
    authenticatedUserId: string | null;
    billingAttempted: boolean;
}

export type SignupFlowAction = "register" | "login" | "start_billing" | "resume_billing";

export function getNextSignupFlowAction(checkpoint: SignupFlowCheckpoint): SignupFlowAction {
    if (!checkpoint.registeredUserId) return "register";
    if (!checkpoint.authenticatedUserId) return "login";
    return checkpoint.billingAttempted ? "resume_billing" : "start_billing";
}

export function createInitialSignupProgressSteps(): IProgressStep[] {
    return [
        {percent: 25, status: "pending"},
        {percent: 50, status: "pending"},
        {percent: 75, status: "pending"},
        {percent: 100, status: "pending"},
    ];
}
